import { AdminOrganizationListStreamSortBy } from 'protocol/api/core/svc_adminka_pb';

import { SubscriptionEndDateFilterValue } from './types';

// The column key a sortable column is sorted by, mapped to what the stream is
// asked to sort by. A column missing here is not sortable.
export const COLUMN_KEY_TO_SORT_BY: Record<
  string,
  AdminOrganizationListStreamSortBy
> = {
  name: AdminOrganizationListStreamSortBy.AdminOrganizationListStreamSortByName,
  email:
    AdminOrganizationListStreamSortBy.AdminOrganizationListStreamSortByOwnerEmail,
  subscriptionEndDate:
    AdminOrganizationListStreamSortBy.AdminOrganizationListStreamSortBySubscriptionEndDate,
};

export const EMPTY_SUBSCRIPTION_END_DATE_FILTER: SubscriptionEndDateFilterValue =
  {
    period: 'all',
    onlyActive: false,
  };
